<script setup lang="ts">
import SignalMetadataLine from '@/V2/documents/document-view/signals/SignalMetadataLine.vue';
import humanizeString from 'humanize-string';

// Props
const props = defineProps<{
  signalGroup: any;
}>();

/** Helpers */
function getViolationData(violation: any) {
  return Object.entries(violation)
    .filter(([key, value]) => key !== 'description')
    .map(([key, value]) => {
      return {
        label: humanizeString(key),
        value: value ? value.toString() : '',
      };
    });
}
</script>

<template>
  <div class="signal-violations d-flex flex-column">
    <div class="violations-list d-flex flex-column i-gap-11">
      <div
        class="violation d-flex flex-column i-gap-6"
        v-for="violation in signalGroup.violations"
        :key="violation.id"
      >
        <div class="description i-text-body-2">
          {{ violation.description }}
        </div>
        <div class="values">
          <signal-metadata-line
            :title="data.label"
            v-for="data of getViolationData(violation)"
            :key="data.label"
          >
            <template #value> {{ data.value }} </template>
          </signal-metadata-line>
        </div>
      </div>
    </div>
  </div>
</template>
